// useUserMentionPopover.js
// Hook to manage user mention popover state

import {useMemo} from 'react';
import {useFloatingInteraction} from './useFloatingInteraction';

/**
 * Hook to manage the user mention popover
 *
 * @returns {Object} Popover state and handlers
 */
export function useUserMentionPopover() {
    const mapMentionData = useMemo(() => {
        return (data) => ({
            id: data.id,
            uid: data.uid || data.id,
            name: data.name,
            label: data.label,
            email: data.email,
            position: data.position,
            headshot: data.headshot,
            isAvailable: data.isAvailable,
        });
    }, []);

    const mentionInteraction = useFloatingInteraction(mapMentionData);

    return {
        anchorEl: mentionInteraction.anchorEl,
        anchorPosition: mentionInteraction.anchorPosition,
        userData: mentionInteraction.data,
        nodePos: mentionInteraction.nodePos,
        view: mentionInteraction.view,
        open: mentionInteraction.open,
        handleUserMentionClick: mentionInteraction.handleOpen,
        handleClose: mentionInteraction.handleClose,
    };
}

